import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/authContext";
import { canAccess } from "../utils/CanAccess";
import { roleRedirect } from "../constant/Constatnt";
import { useSelector } from "react-redux";



const ProtectedRoute = ({
  allowedRole,
  module,
  action = "view",
  children,
}) => {
  const { token, userType, } = useAuth();

  const { permissionMap } = useSelector((state) => state.staffDashboards);


  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRole && userType !== allowedRole) {
    return <Navigate to={roleRedirect[userType] || "/login"} replace />;
  }

  if (module && !canAccess(permissionMap, module, action)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
